import { GetReviewFormsResponseJson } from "@performyard/service-contracts";

import { internalRequest } from "./internal-base-request";

export const getAllReviewForms = async (): Promise<GetReviewFormsResponseJson> => {
	const [response] = await internalRequest<GetReviewFormsResponseJson>(`/v1/reviews/forms`);
	return response;
};
